import logo from './logo.svg';
import Navbar from './assets/components/Navbar/Navbar';
import Soccer from './assets/components/Soccer/Soccer';
import CustomeSoccer from './assets/components/CustomeSoccer/CustomeSoccer';

function App() {
  return (
    <div className="App">
     <Navbar/>
     {/* <Soccer/> */}
     <CustomeSoccer/>
    </div>
  );
}

export default App;
